// extracted by mini-css-extract-plugin
module.exports = {"product":"Products_product__cninL","productActive":"Products_productActive__vCyeY"};